<template>
  <LightBox class="mb-3">
    <FormHeading :h="5">
      {{ $tt('order_summary') }}
    </FormHeading>
    <v-divider class="mb-0" />
    <BasketSummaryProductLine :product="form.product" />

    <v-expand-transition>
      <BasketSummaryUrgencyLine v-if="form.urgency != 'none'" :form />
    </v-expand-transition>

    <BasketSummaryQuantityLine :quantity="form.quantity" />

    <AppBanner
      v-for="variation in applicableVariations"
      :key="variation.name"
      icon="mdi:hand-coin-outline"
    >
      {{ $tt(`product_variation.label.${variation.name}`) }}:
      <PriceSpan operand="+" :price="variation.fee" strong class="ms-1" />
    </AppBanner>

    <v-expand-transition>
      <AppBanner v-if="form.discount" icon="mdi:coupon-outline">
        {{ $tt('discount') }}
        <DiscountChip :discount="form.discount" class="ms-1" />: 
        <PriceSpan operand="−" :price="discountAmount" strong />
      </AppBanner>
    </v-expand-transition>

    <AppBanner v-if="emailVisible" icon="mdi:email-outline">
      {{ $tt('email') }}:
      <strong class="ms-1">{{ form.client.email }}</strong>
    </AppBanner>

    <AppBanner v-if="entryDateVisible && 'entry' in form" icon="mdi:calendar">
      {{ $tt('expected_entry_date') }}:
      <strong class="ms-1">{{ formatDate(form.entry.date) }}</strong>
    </AppBanner>

    <TotalPrice :total class="mt-4" />
  </LightBox>
</template>

<script setup lang="ts">
import type { VisaForm } from '~/types';
import { getApplicableVariations } from '~/helpers/visa-form';

const props = defineProps<{
  form: VisaForm;
  emailVisible?: boolean;
  entryDateVisible?: boolean;
}>();

const form = toRef(props.form);

const { formatDate } = useFormat();
const { total, discountAmount } = useFormPrice(form);
const applicableVariations = computed(() => getApplicableVariations(form.value).filter(v => v.type == 'fee'));
</script>